const generateID = () =>
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  // eslint-disable-next-line implicit-arrow-linebreak
  Math.random()
    .toString(36)
    .substr(2, 8);
export default generateID;
